import Vue from 'vue';

export const chartingFeedbackState = Vue.observable({
  messages: [],
  confirmation: null
});

let feedbackId = 0;

export function dismissChartingFeedback(id) {
  const index = chartingFeedbackState.messages.findIndex(message => message.id === id);
  if (index !== -1) {
    chartingFeedbackState.messages.splice(index, 1);
  }
}

export function addChartingFeedback(message = {}) {
  const item = {
    id: ++feedbackId,
    severity: message.severity || 'info',
    summary: message.summary || '',
    detail: message.detail || '',
    life: Number(message.life || 4000)
  };
  chartingFeedbackState.messages.push(item);
  window.setTimeout(() => dismissChartingFeedback(item.id), item.life);
  return item.id;
}

export function useChartingToast() {
  return { add: addChartingFeedback };
}

export function useChartingConfirm() {
  return {
    require(options = {}) {
      chartingFeedbackState.confirmation = options;
    }
  };
}

export function acceptChartingConfirmation() {
  const confirmation = chartingFeedbackState.confirmation;
  chartingFeedbackState.confirmation = null;
  if (confirmation && typeof confirmation.accept === 'function') {
    confirmation.accept();
  }
}

export function rejectChartingConfirmation() {
  const confirmation = chartingFeedbackState.confirmation;
  chartingFeedbackState.confirmation = null;
  if (confirmation && typeof confirmation.reject === 'function') {
    confirmation.reject();
  }
}
